import PropTypes from 'prop-types';
var propTypes = {
  autoResize: PropTypes.bool,
  className: PropTypes.string,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  height: PropTypes.string,
  helperText: PropTypes.node,
  helperTextState: PropTypes.oneOf(['default', 'error', 'success']),
  helperTextVisibility: PropTypes.oneOf(['auto', 'hidden', 'visible']),
  id: PropTypes.string,
  label: PropTypes.string,
  maxHeight: PropTypes.string,
  maxLength: PropTypes.number,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onHeightChange: PropTypes.func,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  resize: PropTypes.oneOf([true, false, 'both', 'horizontal', 'none', 'vertical']),
  separateLabel: PropTypes.bool,
  value: PropTypes.string
};
export default propTypes;